import type { LocalizedText } from '@spacegame/ui';

/** Shorthand for building a `LocalizedText` — `lt('Deutsch', 'English')`. */
export function lt(de: string, en: string): LocalizedText {
  return { de, en };
}

/**
 * The subset of `App.tsx`'s `ViewId` the tour can navigate to. Duplicated
 * rather than imported from `App.tsx` to keep this content module free of
 * any dependency on the app shell — `App.tsx` imports FROM here, not the
 * other way around.
 */
export type TourViewId =
  | 'overview' | 'buildings' | 'research' | 'shipyard'
  | 'defense' | 'sector' | 'camps' | 'trade' | 'casino' | 'shop' | 'messages' | 'settings';

export interface ChapterSection {
  id: string;
  heading: LocalizedText;
  /** One entry per paragraph. */
  body: LocalizedText[];
  /** Short, boxed callouts — a rule of thumb, a warning, a formula in plain words. */
  tips?: LocalizedText[];
}

export interface Chapter {
  id: string;
  title: LocalizedText;
  summary: LocalizedText;
  sections: ChapterSection[];
}

export interface FaqEntry {
  id: string;
  chapterId?: string;
  question: LocalizedText;
  answer: LocalizedText;
  /** Extra search terms not already present in the question/answer text. */
  keywords?: string[];
}

export interface TourStep {
  id: string;
  /** View to switch to before showing this step. Omit to stay on the current view. */
  navTarget?: TourViewId;
  /** `data-tour-nav` value (nav items) or another `data-tour="..."` attribute to spotlight. Omit for a centred step. */
  targetSelector?: string;
  title: LocalizedText;
  body: LocalizedText;
}
